import {useFormik} from 'formik';
import React from 'react';
import {useNavigate, useParams} from 'react-router';
import * as yup from 'yup';

import {useResetPasswordMutation} from '@/api';

import {PositiveButton} from '../../../components/mypage/MypageLayout';

export const validationSchema = yup.object().shape({
  password: yup
    .string()
    .trim()
    .min(6, 'パスワードは６文字以上で設定してください。')
    .required('パスワードを入力してください'),
  passwordConfirmation: yup
    .string()
    .trim()
    .required('パスワード(確認)を入力してください')
    .oneOf([yup.ref('password'), null], 'パスワードが一致していません'),
});

export default () => {
  const navigate = useNavigate();
  const {token} = useParams<{token: string}>();

  const [resetPassword, {data, loading}] = useResetPasswordMutation({
    onCompleted: (data) => {
      if (!data?.resetPassword?.error) {
        navigate('/registration/success');
      }
    },
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirmation: '',
      token,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      void resetPassword({
        variables: {input: values},
      });
    },
  });

  return (
    <div className="mx-auto w-[400px] pt-[90px] text-center">
      <h1 className="mb-[70px] text-center text-[26px] font-medium text-neutral-700">
        パスワードの再設定
      </h1>

      {data?.resetPassword?.error && (
        <div className="mb-4 rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">
          <p>{data.resetPassword.error}</p>
        </div>
      )}

      <div className="mb-10 mt-5 text-xs leading-[1.5] text-neutral-900 [&_p]:mb-0">
        <p>変更するパスワードを入力してください。</p>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="mb-[1em]">
          <label className="text-left text-xs opacity-[0.37] [color:#333333]">
            新しいパスワード
          </label>
          <input
            name="password"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="block h-[45px] w-full border border-neutral-100 bg-neutral-100"
          />
          {formik.touched.password && formik.errors.password && (
            <p className="mt-1 text-left text-sm text-red-600">
              {formik.errors.password}
            </p>
          )}
        </div>

        <div className="mb-[1em]">
          <label className="text-left text-xs opacity-[0.37] [color:#333333]">
            新しいパスワード(確認)
          </label>
          <input
            name="passwordConfirmation"
            type="password"
            value={formik.values.passwordConfirmation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="block h-[45px] w-full border border-neutral-100 bg-neutral-100"
          />
          {formik.touched.passwordConfirmation &&
            formik.errors.passwordConfirmation && (
              <p className="mt-1 text-left text-sm text-red-600">
                {formik.errors.passwordConfirmation}
              </p>
            )}
        </div>

        <div className="my-[60px] [&_button]:w-full">
          <PositiveButton
            type="submit"
            size="large"
            disabled={loading || !formik.isValid}>
            送信
          </PositiveButton>
        </div>
      </form>
    </div>
  );
};
